import { baseRoute } from '../../../constants/routes';

export const QUESTIONS_ROUTE = baseRoute + '/calendar-questions';
export const QUIZZES_LIST_ROUTE = baseRoute + '/quizzes-list';
export const QUESTION_COPY_ROUTE = baseRoute + '/calendar-question-copy';
export const QUESTION_COVER_ROUTE = baseRoute + '/calendar-question-cover';
export const GET_HATCH_QUESTIONS_ROUTE = baseRoute + '/hatch/question-list';
export const CALENDAR_QUESTION_PIN_ROUTE = baseRoute + '/calendar-question-pin';
export const QUESTION_DROP_ROUTE = baseRoute + '/hatch/order-questions';

export const CREATE_CALENDAR_QUESTION = 'CREATE_CALENDAR_QUESTION';
export const CREATE_CALENDAR_QUESTION_SUCCESS = 'CREATE_CALENDAR_QUESTION_SUCCESS';

export const GET_HATCH_QUESTIONS = 'GET_HATCH_QUESTIONS';
export const GET_HATCH_QUESTIONS_SUCCESS = 'GET_HATCH_QUESTIONS_SUCCESS';

export const DELETE_CALENDAR_QUESTION = 'DELETE_CALENDAR_QUESTION';
export const DELETE_CALENDAR_QUESTION_SUCCESS = 'DELETE_CALENDAR_QUESTION_SUCCESS';

export const GET_CALENDAR_QUIZZES_LIST = 'GET_CALENDAR_QUIZZES_LIST';
export const GET_CALENDAR_QUIZZES_LIST_SUCCESS = 'GET_CALENDAR_QUIZZES_LIST_SUCCESS';

export const CALENDAR_QUESTION_COPY = 'CALENDAR_QUESTION_COPY';
export const CALENDAR_QUESTION_COPY_SUCCESS = 'CALENDAR_QUESTION_COPY_SUCCESS';

export const UPLOAD_CALENDAR_QUESTION_COVER = 'UPLOAD_CALENDAR_QUESTION_COVER';
export const UPLOAD_CALENDAR_QUESTION_COVER_SUCCESS = 'UPLOAD_CALENDAR_QUESTION_COVER_SUCCESS';
export const UPDATE_CALENDAR_QUESTION = 'UPDATE_CALENDAR_QUESTION';
export const UPDATE_CALENDAR_QUESTION_SUCCESS = 'UPDATE_CALENDAR_QUESTION_SUCCESS';

export const CALENDAR_QUESTION_PIN = 'CALENDAR_QUESTION_PIN';
export const CALENDAR_QUESTION_PIN_SUCCESS = 'CALENDAR_QUESTION_PIN_SUCCESS';

export const UPDATE_CALENDAR_QUESTION_DRAG_DROP = 'CALENDAR_DROP';
export const UPDATE_CALENDAR_QUESTION_DRAG_DROP_SUCCESS = 'UPDATE_CALENDAR_QUESTION_DRAG_DROP_SUCCESS';

export const UPDATE_CALENDAR_QUESTION_COVER = 'UPDATE_CALENDAR_QUESTION_COVER';
export const UPDATE_CALENDAR_QUESTION_COVER_SUCCESS = 'UPDATE_CALENDAR_QUESTION_COVER_SUCCESS';

